<form [formGroup]="intervalSelectForm">
  Time ( offset: {{this.offset}} )<br>

  <mat-form-field style="width:150px;">
    <mat-select [(value)]="intervalSelectForm.value.startTime" formControlName="startTime">
      @for ( i of time; track  i) {
        <mat-option [value]="i.value"> {{i.name}} </mat-option>
      }
    </mat-select>
    @for (validation of validationMessages.startTime; track validation) {
      <mat-error>
        @if (intervalSelectForm.get('startTime').hasError(validation.type) && (intervalSelectForm.get('startTime').dirty || intervalSelectForm.get('startTime').touched)) {
          <mat-error class="error-message"
            >
          {{validation.message}}</mat-error>
        }
      </mat-error>
    }
  </mat-form-field>
  &nbsp;&nbsp;to&nbsp;&nbsp;
  <mat-form-field style="width:150px;">
    <mat-select [(value)]="intervalSelectForm.value.endTime" formControlName="endTime">
      @for ( i of time; track  i) {
        <mat-option [value]="i.value"> {{i.name}} </mat-option>
      }
    </mat-select>
    @for (validation of validationMessages.endTime; track validation) {
      <mat-error>
        @if (intervalSelectForm.get('endTime').hasError(validation.type) && (intervalSelectForm.get('endTime').dirty || intervalSelectForm.get('endTime').touched)) {
          <mat-error class="error-message"
            > {{validation.message}}
          </mat-error>
        }
      </mat-error>
    }
  </mat-form-field>
  &nbsp;&nbsp;&nbsp;&nbsp;
  <mat-form-field style="width:150px;">
    <mat-select [(value)]="intervalSelectForm.value.timeZone" formControlName="timeZone">
      @for ( i of timeZones; track  i) {
        <mat-option [value]="i.value"> {{i.name}} </mat-option>
      }
    </mat-select>
    @for (validation of validationMessages.timeZone; track validation) {
      <mat-error>
        @if (intervalSelectForm.get('timeZone').hasError(validation.type) && (intervalSelectForm.get('timeZone').dirty || intervalSelectForm.get('timeZone').touched)) {
          <mat-error class="error-message"
            > {{validation.message}}
          </mat-error>
        }
      </mat-error>
    }
  </mat-form-field>

  <table style="width: 100%; border-collapse: collapse;">
    <tr>
      <td style="vertical-align: top; border-right: 1px solid #ccc; padding-right: 20px; width: 150px;">
        <p style="margin: 0 0 12px 0; font-weight: 500;">Repeat</p>
        <mat-radio-group formControlName="frequency" style="display: flex; flex-direction: column; gap: 8px;">
          <mat-radio-button [value]="0">Off</mat-radio-button>
          <mat-radio-button [value]="1">Daily</mat-radio-button>
          <mat-radio-button [value]="2">Weekly</mat-radio-button>
          <mat-radio-button [value]="3">Monthly</mat-radio-button>
          <mat-radio-button [value]="4">Yearly</mat-radio-button>
        </mat-radio-group>
        @for (validation of validationMessages.frequency; track validation) {
          <mat-error>
            @if (intervalSelectForm.get('frequency').hasError(validation.type) && (intervalSelectForm.get('frequency').dirty || intervalSelectForm.get('frequency').touched)) {
              <mat-error class="error-message"
                >
              {{validation.message}}</mat-error>
            }
          </mat-error>
        }
      </td>
      <td style="padding-left: 20px; vertical-align: top;">
        <!-- Daily Frequency -->
        @if (intervalSelectForm.get('frequency').value === 1) {
          <div style="padding: 8px 0;">
            <div style="margin-bottom: 12px;">
              <span style="display: inline-block; margin-right: 8px;">Repeat every</span>
              <mat-form-field style="width: 60px; display: inline-block; vertical-align: middle;">
                <input matInput formControlName="frequencySkip" readonly="{{formReadOnly}}">
                @for (validation of validationMessages.frequencySkip; track validation) {
                  <mat-error>
                    @if (intervalSelectForm.get('frequencySkip').hasError(validation.type) && (intervalSelectForm.get('frequencySkip').dirty || intervalSelectForm.get('frequencySkip').touched)) {
                      <mat-error class="error-message"
                        >
                      {{validation.message}}</mat-error>
                    }
                  </mat-error>
                }
              </mat-form-field>
              <span style="margin-left: 8px;">day(s)</span>
            </div>
            <div style="margin-top: 16px;">
              <mat-checkbox formControlName="excludeWeekends">Exclude Weekends</mat-checkbox>
            </div>
          </div>
        }

        <!-- Weekly Frequency -->
        @if (intervalSelectForm.get('frequency').value === 2) {
          <div style="padding: 8px 0;">
            <div style="margin-bottom: 12px;">
              <span style="display: inline-block; margin-right: 8px;">Repeat every</span>
              <mat-form-field style="width: 60px; display: inline-block; vertical-align: middle;">
                <input matInput formControlName="frequencySkip" readonly="{{formReadOnly}}">
                @for (validation of validationMessages.frequencySkip; track validation) {
                  <mat-error>
                    @if (intervalSelectForm.get('frequencySkip').hasError(validation.type) && (intervalSelectForm.get('frequencySkip').dirty || intervalSelectForm.get('frequencySkip').touched)) {
                      <mat-error class="error-message"
                        >
                      {{validation.message}}</mat-error>
                    }
                  </mat-error>
                }
              </mat-form-field>
              <span style="margin-left: 8px;">week(s) on</span>
            </div>
            <div style="margin-top: 16px; display: flex; flex-direction: column; gap: 6px;">
              <mat-checkbox formControlName="mon">Mon</mat-checkbox>
              <mat-checkbox formControlName="tue">Tue</mat-checkbox>
              <mat-checkbox formControlName="wed">Wed</mat-checkbox>
              <mat-checkbox formControlName="thu">Thu</mat-checkbox>
              <mat-checkbox formControlName="fri">Fri</mat-checkbox>
              <mat-checkbox formControlName="sat">Sat</mat-checkbox>
              <mat-checkbox formControlName="sun">Sun</mat-checkbox>
            </div>
          </div>
        }

        <!-- Monthly Frequency -->
        @if (intervalSelectForm.get('frequency').value === 3) {
          <div style="padding: 8px 0;">
            <div style="border-bottom: 1px solid #ccc; padding-bottom: 16px; margin-bottom: 16px;">
              <mat-radio-group formControlName="monthType" style="display: flex; flex-direction: column; gap: 8px;">
                <mat-radio-button [value]="1">Specific date</mat-radio-button>
                <mat-radio-button [value]="2">Specific day</mat-radio-button>
              </mat-radio-group>
            </div>
            <!-- Monthly - Specific date -->
            @if (intervalSelectForm.get('monthType').value === 1) {
              <div style="padding: 8px 0;">
                <div style="margin-bottom: 8px;">Repeat on the</div>
                <div style="margin-bottom: 12px;">
                  <mat-form-field style="width: 60px; display: inline-block; vertical-align: middle;">
                    <input matInput formControlName="dayOfMonth" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.dayOfMonth; track validation) {
                      <mat-error>
                        @if (intervalSelectForm.get('dayOfMonth').hasError(validation.type) && (intervalSelectForm.get('dayOfMonth').dirty || intervalSelectForm.get('dayOfMonth').touched)) {
                          <mat-error class="error-message"
                            >
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                  <span style="margin: 0 8px;">day of every</span>
                  <mat-form-field style="width: 60px; display: inline-block; vertical-align: middle;">
                    <input matInput formControlName="frequencySkip" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.frequencySkip; track validation) {
                      <mat-error>
                        @if (intervalSelectForm.get('frequencySkip').hasError(validation.type) && (intervalSelectForm.get('frequencySkip').dirty || intervalSelectForm.get('frequencySkip').touched)) {
                          <mat-error class="error-message"
                            >
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                  <span style="margin-left: 8px;">month(s).</span>
                </div>
              </div>
            }
            <!-- Monthly - Specific day -->
            @if (intervalSelectForm.get('monthType').value === 2) {
              <div style="padding: 8px 0;">
                <div style="margin-bottom: 8px;">Repeat on the</div>
                <div style="margin-bottom: 12px; display: flex; gap: 8px; align-items: center; flex-wrap: wrap;">
                  <mat-form-field style="min-width: 120px;">
                    <mat-select [(value)]="intervalSelectForm.value.positionInInterval" formControlName="positionInInterval">
                      @for (i of positionInIntervals; track i) {
                        <mat-option [value]="i.value">{{i.name}}</mat-option>
                      }
                    </mat-select>
                    @for (validation of validationMessages.positionInInterval; track validation) {
                      <mat-error>
                        @if (intervalSelectForm.get('positionInInterval').hasError(validation.type) && (intervalSelectForm.get('positionInInterval').dirty || intervalSelectForm.get('positionInInterval').touched)) {
                          <mat-error class="error-message"
                            >
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field style="min-width: 120px;">
                    <mat-select [(value)]="intervalSelectForm.value.dayOfWeek" formControlName="dayOfWeek">
                      @for (i of days; track i) {
                        <mat-option [value]="i.value">{{i.name}}</mat-option>
                      }
                    </mat-select>
                    @for (validation of validationMessages.dayOfWeek; track validation) {
                      <mat-error>
                        @if (intervalSelectForm.get('dayOfWeek').hasError(validation.type) && (intervalSelectForm.get('dayOfWeek').dirty || intervalSelectForm.get('dayOfWeek').touched)) {
                          <mat-error class="error-message"
                            >
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div style="margin-top: 8px;">
                  <span style="margin-right: 8px;">of every</span>
                  <mat-form-field style="width: 60px; display: inline-block; vertical-align: middle;">
                    <input matInput formControlName="frequencySkip" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.frequencySkip; track validation) {
                      <mat-error>
                        @if (intervalSelectForm.get('frequencySkip').hasError(validation.type) && (intervalSelectForm.get('frequencySkip').dirty || intervalSelectForm.get('frequencySkip').touched)) {
                          <mat-error class="error-message"
                            >
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                  <span style="margin-left: 8px;">month(s).</span>
                </div>
              </div>
            }
          </div>
        }

        <!-- Yearly Frequency -->
        @if (intervalSelectForm.get('frequency').value === 4) {
          <div style="padding: 8px 0;">
            <div style="border-bottom: 1px solid #ccc; padding-bottom: 16px; margin-bottom: 16px;">
              <mat-radio-group formControlName="yearType" style="display: flex; flex-direction: column; gap: 8px;">
                <mat-radio-button [value]="1">Specific date</mat-radio-button>
                <mat-radio-button [value]="2">Specific day</mat-radio-button>
              </mat-radio-group>
            </div>
            <!-- Yearly - Specific date -->
            @if (intervalSelectForm.get('yearType').value === 1) {
              <div style="padding: 8px 0;">
                <div style="margin-bottom: 12px;">Repeat on</div>
                <div style="margin-bottom: 12px; display: flex; gap: 12px; align-items: center; flex-wrap: wrap;">
                  <mat-form-field style="flex: 1; min-width: 150px;">
                    <mat-label>Month</mat-label>
                    <mat-select [(value)]="intervalSelectForm.value.monthOfYear" formControlName="monthOfYear">
                      @for (i of months; track i) {
                        <mat-option [value]="i.value">{{i.name}}</mat-option>
                      }
                    </mat-select>
                    @for (validation of validationMessages.monthOfYear; track validation) {
                      <mat-error>
                        @if (intervalSelectForm.get('monthOfYear').hasError(validation.type) && (intervalSelectForm.get('monthOfYear').dirty || intervalSelectForm.get('monthOfYear').touched)) {
                          <mat-error class="error-message"
                            >
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                  <mat-form-field style="flex: 1; min-width: 100px;">
                    <mat-label>Day</mat-label>
                    <input matInput formControlName="dayOfMonth" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.dayOfMonth; track validation) {
                      <mat-error>
                        @if (intervalSelectForm.get('dayOfMonth').hasError(validation.type) && (intervalSelectForm.get('dayOfMonth').dirty || intervalSelectForm.get('dayOfMonth').touched)) {
                          <mat-error class="error-message"
                            >
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div style="margin-top: 8px;">
                  <span style="margin-right: 8px;">every</span>
                  <mat-form-field style="width: 60px; display: inline-block; vertical-align: middle;">
                    <input matInput formControlName="frequencySkip" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.frequencySkip; track validation) {
                      <mat-error>
                        @if (intervalSelectForm.get('frequencySkip').hasError(validation.type) && (intervalSelectForm.get('frequencySkip').dirty || intervalSelectForm.get('frequencySkip').touched)) {
                          <mat-error class="error-message"
                            >
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                  <span style="margin-left: 8px;">year(s).</span>
                </div>
              </div>
            }
            <!-- Yearly - Specific day -->
            @if (intervalSelectForm.get('yearType').value === 2) {
              <div style="padding: 8px 0;">
                <div style="margin-bottom: 12px;">Repeat every</div>
                <div>
                  <mat-form-field style="width: 60px; display: inline-block; vertical-align: middle;">
                    <input matInput formControlName="frequencySkip" readonly="{{formReadOnly}}">
                    @for (validation of validationMessages.frequencySkip; track validation) {
                      <mat-error>
                        @if (intervalSelectForm.get('frequencySkip').hasError(validation.type) && (intervalSelectForm.get('frequencySkip').dirty || intervalSelectForm.get('frequencySkip').touched)) {
                          <mat-error class="error-message"
                            >
                          {{validation.message}}</mat-error>
                        }
                      </mat-error>
                    }
                  </mat-form-field>
                  <span style="margin-left: 8px;">year(s).</span>
                </div>
              </div>
            }
          </div>
        }
      </td>
    </tr>
  </table>
</form>
